import type { FC, ReactNode } from 'react';
import { Icon } from '@iconify/react';
import { useExpandAnimation } from '@utils/animationHooks';

type AccordionButtonProps = {
  title: string;
  headerRightElements?: ReactNode;
  subtitle?: string;
  children: ReactNode;
  expanded?: boolean;
  backgroundClass?: string;
  isCard?: boolean;
};

const AccordionButton: FC<AccordionButtonProps> = ({
  title,
  headerRightElements,
  subtitle,
  children,
  expanded = false,
  backgroundClass = '',
  isCard = false,
}) => {
  const { contentRef, isExpanded, toggleExpanded } = useExpandAnimation<HTMLDivElement>(expanded);

  return (
    <div className="mb-4">
      <div className="flex pb-5 pr-0 border-b-2 border-color-gray p-1.5 justify-between items-center">
        <button className="flex justify-center items-center bg-none" onClick={toggleExpanded}>
          <Icon
            className={`text-2xl text-center font-bold transition-transform text-color-secondary ${
              isExpanded ? 'rotate-90' : ''
            }`}
            icon="bx:right-arrow"
          />
          <h3 className="font-bold text-lg text-color-primary pl-2.5 flex flex-col text-left">
            {title}
            {subtitle ? <span className="inline-flex text-sm font-normal">{subtitle}</span> : null}
          </h3>
        </button>
        {headerRightElements ? headerRightElements : null}
      </div>
      <div ref={contentRef} className="h-0 overflow-hidden transition-[height,padding]">
        <div className={`p-3 ${backgroundClass}`}>
          <div className={`${isCard ? 'bg-color-white rounded-md' : ''}`}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default AccordionButton;
